import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { breakpoints } from 'styles/basic';

interface AlbumProps {
  flex?: boolean | undefined;
}
interface AlbumPhotoProps {
  sorce?: string | undefined;
}

const Wrapper = styled.div`

`;

const AlbumWrapper = styled.div<AlbumProps>`
  ${(props) => props.flex && css`
    @media (min-width: ${breakpoints.smallLaptop}) {
      display: flex;
    }
  `};
`;

const SideWrapper = styled.aside`
  width: 22rem;
  margin-bottom: 3rem;

  @media (min-width: ${breakpoints.smallLaptop}) {
    margin-right: 3rem;
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.laptop}) {
    width: 30rem;
  }
`;

const SideInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 1rem;
  font-size: 1.4rem;
  color: ${(props) => props.theme.colorGray.secondary};

  & + & {
    margin-top: 1rem;
  }

  img {
    width: 2rem;
    height: auto;
    margin-left: auto;
    border: .1rem solid ${(props) => props.theme.color.gray};
  }
`;

const SectionWrapper = styled.aside`
  width: 100%;
`;

const AlbumDescription = styled.div`
  padding: 1.2rem 2rem 2rem;
  border: .3rem solid  ${(props) => props.theme.color.gray};
  border-radius: .5rem;

  p:last-of-type {
    margin-bottom: 0;
  }
`;

const AlbumPhoto = styled.div<AlbumPhotoProps>`
  display: block;
  width: 22rem;
  height: 22rem;
  margin-bottom: 1rem;
  border: .1rem solid ${(props) => props.theme.color.gray};
  border-radius: .5rem;
  background: ${(props) => `url(${props.sorce}) center center no-repeat` || props.theme.color.gray};
  background-size: contain;

  @media (min-width: ${breakpoints.laptop}) {
    width: 30rem;
    height: 30rem;
  }
`;

const SongsWrapper = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 3rem;
`;

export {
  Wrapper,
  AlbumWrapper,
  SideWrapper,
  SideInfoBox,
  SectionWrapper,
  AlbumDescription,
  AlbumPhoto,
  SongsWrapper
};
